import { render, staticRenderFns } from "./RevenueByInstructorPanel.vue?vue&type=template&id=9c4f498c&scoped=true"
import script from "./RevenueByInstructorPanel.vue?vue&type=script&lang=js"
export * from "./RevenueByInstructorPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4f498c",
  null
  
)

export default component.exports